import { ReactNode } from 'react';
import { NoResult } from 'ui/illustrations';
import { Spinner } from 'ui/spinner';
import { SpinnerFlexSpacer, StyledEmptyState } from './Table.styled';

export const TABLE_BODY_TEXT = {
  emptyStateTitle: 'No links to display',
  emptyStateSubtitle: 'If you have links to redirect they will be shown here.',
  zeroStateTitle: 'No results',
  zeroStateSubtitle: 'Try removing filters or changing your search query.',
};

type TableBodyProps = {
  children: ReactNode;
  currentLinksCount: number;
  isLoading: boolean;
  totalLinksCount: number;
};

/**
 * Wrapper component to handle empty and zero state  messages
 * and passes through children if there are links to display
 */
export const TableBody = ({
  children,
  currentLinksCount,
  isLoading,
  totalLinksCount,
}: TableBodyProps) => {
  /** Loading state */
  if (isLoading) {
    return (
      <SpinnerFlexSpacer justifyContent="center">
        <Spinner />
      </SpinnerFlexSpacer>
    );
  }

  /** No links to display at all */
  if (totalLinksCount === 0) {
    return (
      <StyledEmptyState
        Illustration={NoResult}
        title={TABLE_BODY_TEXT.emptyStateTitle}
        subtitle={TABLE_BODY_TEXT.emptyStateSubtitle}
      />
    );
  }

  /** Filtered to zero results */
  if (currentLinksCount === 0) {
    return (
      <StyledEmptyState
        Illustration={NoResult}
        title={TABLE_BODY_TEXT.zeroStateTitle}
        subtitle={TABLE_BODY_TEXT.zeroStateSubtitle}
      />
    );
  }
  return <>{children}</>;
};
